import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_SUBDIVISIONS_ENDPOINT: SUBDIVISIONS_ENDPOINT,
} = process.env;

export const urlFor = countryCode => {
  const templateUrl = `${ONBOARDING_API_HOST}${SUBDIVISIONS_ENDPOINT}`;

  return templateUrl.replace('{countryCode}', countryCode);
};

export default class SubdivisionsAPI {
  static getSubdivisionsFor = (countryCode, token) =>
    APIClient.get(urlFor(countryCode), token).then(response =>
      // eslint-disable-next-line camelcase
      response.data.map(({ subdivision_code, subdivision_name }) => ({
        value: subdivision_code,
        label: subdivision_name,
      })),
    );
}
